<template>
  <section class="checkout-section">
    <div class="checkout-section__skip">
      <NavButton
        :text="data.addons.bookWithoutExtensionText"
        :stepAmount="2"
        @beforeNextStep="bookWithoutExtension"
      />
    </div>

    <div class="checkout-section__header">
      <h2 class="checkout-section__title">{{data.addons.title}}</h2>
      <div class="checkout-section__description" v-html="data.addons.descriptionHtml"></div>
    </div>

    <AddOnList v-if="addonData.addOns && addonData.addOns.length" :initialData="addonData" :brand="data.brandNameFormatted"/>

    <div class="checkout-section__footer">
      <NavButton :back="true" text="Back" :isFirstPage="true" />
      <NavButton
        :text="data.addons.bookWithoutExtensionText"
        :stepAmount="2"
        @beforeNextStep="bookWithoutExtension"
      />
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import AddOnList from '@/vue/components/Tour/AddOnList.vue';
import NavButton from './../Components/NavButton.vue';
import {Brand} from './../../../../brand.js';

export default {
  name: 'Addon',

  components: {
    AddOnList,
    NavButton
  },

  data: function() {
    return {
      Brand
    };
  },

  computed: mapState('checkout', ['data', 'addonData']),

  created() {
    this.$store.dispatch('checkout/getAddons').then(() => {
      if (!this.addonData.addOns.length) {
        this.$store.dispatch('checkout/getDepartureDetails');
        this.$store.commit('checkout/nextStep', 2);
      }
    });
  },

  activated() {
    this.$store.commit('checkout/resetTourCode');
  },

  methods: {
    bookWithoutExtension() {
      this.$store.dispatch('checkout/getDepartureDetails');
    }
  }
};
</script>